<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button autoHide="true" data-cy="myListings-hdr-menuBtn"></ion-menu-button>

    </ion-buttons>
    <ion-buttons slot="end">
      <app-profile-component data-cy="myListings-hdr-profileBtn" (click)="openMyProfile()"></app-profile-component>
      <ion-button *ngIf="!offlineMode" (click)="openHelp()" data-cy="myListings-hdr-helpBtn">
        <ion-icon slot="icon-only" name="help-circle-sharp"></ion-icon>
      </ion-button>

      <ion-button *ngIf="offlineMode" (click)="common.openOfflineModal()">
        <ion-icon slot="icon-only" name="cloud-offline-outline"></ion-icon>
      </ion-button>

    </ion-buttons>
    <ion-title data-cy="myListings-hdr-title">Listings</ion-title>
  </ion-toolbar>

</ion-header>
<ion-content>
  <div *ngIf="isUserOffline()" class="offline-banner">
    Some data may not be up-to-date while offline <ion-icon name="cloud-offline-outline"></ion-icon>
  </div>

  <div style="display: flex;" [style.flexDirection]="calendarToDisplay === 'bottom' ? 'column-reverse' : 'column'">
    <div *ngIf="shouldDisplayCalendar" [ngClass]="calendarToDisplay === 'bottom' ? 'calendar-bottom' : 'calendar-top'"
      class="calendar-container">
      <div *ngIf="displayCalendarLoadingIndicator" class="open-house-title">
        <ion-skeleton-text animated style="height:54px; width:1200px;" />
      </div>

      <div *ngIf="!displayCalendarLoadingIndicator" class="open-house-title">
        Scheduler
        <ion-button (click)="openSchedulerInfo()" class="info-btn" fill="clear" mode="md" size="small">
          <ion-icon slot="icon-only" name="information-circle-sharp" />
        </ion-button>
        <ion-button (click)="toggleCalendarCollapse()" class="calendar-collapse-button" mode="md" fill="clear"
          size="small">
          <ion-icon name="chevron-down-outline" class="icon-with-outline"
            [style.transform]="'rotate(' + (isCalendarCollapsed ? 180 : 0) + 'deg)'"
            [style.transition]="'transform 0.3s ease-in-out'" />
        </ion-button>
      </div>

      <h1 *ngIf="pendingFreeEvents > 0" class="open-house-subtitle">
        <div class="circle green-circle"></div>
        {{ pendingFreeEvents }} Upcoming Open House{{ pendingFreeEvents === 1 ? '' : 's' }} Available to Host
      </h1>

      <div class="collapsy">
        <open-house-scheduler #calendar [mode]="'agent'" (onEventsChange)="onOpenHouseEventsChanged($event)"
          (onSchedulerInitialized)="onSchedulerComponentInitialized()" />
      </div>
    </div>

    <div class="appPage">

      <div *ngIf="myListings.length !== 0 && !showRefresh && !loading">
        <div class="listing-items-header">
          <span data-cy="myListings-filledList-numberOfListings">{{listingsLabel}}</span>
          <ion-button class="add-listing" tappable (click)="createNewListing()" color="primary"
            data-cy="myListings-filledList-addListingBtn">
            <ion-icon class="ion-margin-end" name="add-sharp"></ion-icon>
            <ion-label>Add Listing </ion-label>
          </ion-button>
        </div>
        <ion-list class="listing-items" data-cy="myListings-filledList-itemsList">

          <div *ngFor="let listing of finalResPaginated; trackBy: listingsTrackByFn; let i = index">
            <app-listing-item [id]="listing.id" *ngIf="listing.archived !== true" [attr.data-index]="i"
              class="listing-item" (click)="listingClicked($event,listing)" [listing]="listing"
              (onEvents)="listingEvents($event)" [content]="content"
              [openHouseEvents]="agentsOpenHouseEvents[listing.id]" />

          </div>
        </ion-list>

        <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
          <ion-infinite-scroll-content loadingSpinner="crescent"></ion-infinite-scroll-content>
        </ion-infinite-scroll>

        <!-- Show tutorial image ir either the first listing is the sample listion and we are not showing the calendar -->
        <div *ngIf="myListings.length && myListings[0].sampleListing === true && !shouldDisplayCalendar"
          class="sampleGuideImage">
          <img src="assets/imgs/sampleListingsDesktop.png">
        </div>

      </div>
      
      <div *ngIf="showRefresh && !loading" class="refresh-holder">
        <ion-button ion-button (click)="refreshPage()">Refresh</ion-button>
      </div>

      <div *ngIf="showSkeleton && !showRefresh && !loading" class="skeleton-holder"
        data-cy="myListings-emptyList-skeleton">

        <div class="no-listings-wrapper">
          <img src="/assets/imgs/empty_listing.svg" data-cy="myListings-emptyList-img" />
          <div class="label" data-cy="myListings-emptyList-dscr">
            Hey, it’s lonely in here.
          </div>
          <ion-button tappable (click)="createNewListing()" color="primary"
            data-cy="myListings-emptyList-addListingBtn">
            <ion-label>Add Listing</ion-label>
            <ion-icon class="ion-margin-start" name="add-sharp"></ion-icon>
          </ion-button>
        </div>

      </div>

      <div *ngIf="loading" class="full-width full-height">
        <ng-container *ngFor="let item of [1, 2, 3]">
          <div class="skeletonContainer" *ngIf="!loaded">
            <ion-skeleton-text animated style="height:80px; width:116px;"></ion-skeleton-text>
            <div class="skeletonSub">
              <ion-skeleton-text animated style="height:12px; width:65%; margin-top:5px;"></ion-skeleton-text>
              <ion-skeleton-text animated style="height:12px; width:60%; margin-top:5px;"></ion-skeleton-text>
              <ion-skeleton-text animated style="height:12px; width:50%; margin-top:5px;"></ion-skeleton-text>
            </div>
          </div>
        </ng-container>
      </div>

    </div>
  </div>
</ion-content>